import React from 'react'
import { Box } from 'front-end/src/components'
import IconBadge from '../../../components/common/icon/IconBadge'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import IconEnergy from '../../../components/common/icon/IconEnergy'
import { brandColors } from '../../../../../shared/basicPalette'
import { t } from '@lingui/macro'
import { PathwayRelatedInstancesFragment } from '../../manage-pathway-page/ManagePathwayPage.codegen'
import {
  RelatedInstanceItem,
  RelatedInstancesWrapper
} from '../../../components/common/related-instances/RelatedInstances'
import { uniqBy } from 'lodash'

export const PathwayRelatedInstances = ({
  pathway
}: {
  pathway: PathwayRelatedInstancesFragment
}) => {
  const showRelated =
    pathway.relatedCampaignsByActions.length +
    pathway.relatedCampaignsByFilters.length +
    pathway.relatedCertifications.length

  if (!showRelated) {
    return null
  }

  const campaignsMerged = [
    ...pathway.relatedCampaignsByActions,
    ...pathway.relatedCampaignsByFilters
  ]

  const campaignsWithoutDuplicates = uniqBy(campaignsMerged, 'id')

  return (
    <Box mb="16px">
      <RelatedInstancesWrapper>
        {pathway.relatedCertifications.map((certification) => (
          <RelatedInstanceItem
            key={`certification-${certification.id}`}
            id={certification.id}
            href={`${linkBuilder.certificationsDetail(certification.id)}`}
            icon={<IconBadge color={brandColors.grey.mid} />}
            name={certification.name}
            additionalInfo={certification.author?.userIdentity}
            tooltip={t`Certification`}
          />
        ))}

        {campaignsWithoutDuplicates.map((campaign) => {
          let usageTypes: string[] = []
          if (
            pathway.relatedCampaignsByFilters.find(
              (campaignFilter) => campaignFilter.id === campaign.id
            )
          ) {
            usageTypes.push(t`audience`)
          }
          if (
            pathway.relatedCampaignsByActions.find(
              (campaignAction) => campaignAction.id === campaign.id
            )
          ) {
            usageTypes.push(t`action`)
          }

          return (
            <RelatedInstanceItem
              key={`campaign-${campaign.id}`}
              id={campaign.id}
              href={`${linkBuilder.campaign(campaign.id)}`}
              icon={<IconEnergy color={brandColors.grey.mid} />}
              name={campaign.name}
              additionalInfo={campaign.author?.userIdentity}
              tooltip={`${t`Campaign`}: ${usageTypes.join(', ')}`}
            />
          )
        })}
      </RelatedInstancesWrapper>
    </Box>
  )
}
